import {
  Card,
  Checkbox,
  Dialog,
  Drawer,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { font } from "../../../styles/font";
import {
  AccordionDetailsMA,
  AccordionMA,
  AccordionSummaryMA,
  ButtonMA,
  TextFieldMA,
} from "../../../styles/styledComponents";
import { theme } from "../../../styles/theme";
import { ButtonCustom } from "../../../components/button";
import CancelIcon from "@mui/icons-material/Cancel";
import AdminDashboardTable from "../../../components/table/adminDashboardTable";
import { ApplicationContext } from "../../../context/application_ctx";
import BusinessIcon from "@mui/icons-material/Business";
// import { LicenseIconAdmin } from "../../../svgIcons/icons";
import ContactsIcon from "@mui/icons-material/Contacts";
import { AccountBalance, Cancel, Close, Info, Search } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { stringToArray } from "../../../utility/string";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { DatePicker } from "@mui/x-date-pickers";
import {
  markRequest_API,
  referalList_Api,
} from "../../../api/controllers/adminController";
import { GlobalLoaders } from "../../../components/loaders/globalLoader";
import useErrorHandler from "../../../utility/useErrorHandler";
import { HttpStatusCode } from "axios";

export const AdminNav = ({
  organisationList,
  cardFilter,
  currentLicenceFilter,
  setCurrentLicenceFilter,
  setAdminDock,
  pathName,
  setSearch
}) => {
  const navigate = useNavigate();

  let tabRoutes = ["company", "org-query", "referrals"];
  useEffect(() => {
    if (!tabRoutes?.includes(pathName)) {
      navigate("/admin-dashboard?company", { replace: true });
    }
  }, []);
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      gap={3}
      minWidth="11%"
      // height="100%"
      borderRadius="8px"
      backgroundColor={theme.col_4}
      pt={3}
      // flexWrap="wrap"
      // border="2px solid blue"
    >
      {/* <DashboardCard
        title={"company"}
        setAdminDock={setAdminDock}
        count={organisationList?.length}
        type={cardFilter.all}
        currentLicenceFilter={currentLicenceFilter}
        setCurrentLicenceFilter={setCurrentLicenceFilter}
        isCurrentFilter={currentLicenceFilter === cardFilter.all}
        icon={<BusinessIcon sx={{ fontSize: 60, color: theme.col_3 }} />}
      /> */}

      {/* <DashboardCard
                title={"Trial"}
                count={
                  organisationList?.filter(
                    (item, index) => item.licenseBatch.length === 1
                  )?.length
                }
                type={cardFilter.demo}
                currentLicenceFilter={currentLicenceFilter}
                setCurrentLicenceFilter={setCurrentLicenceFilter}
                isCurrentFilter={currentLicenceFilter === cardFilter.demo}
                icon={<LicenseIconAdmin />}
              /> */}

      {/* <DashboardCard
                title={"Standard"}
                count={
                  organisationList?.filter(
                    (item, index) => item.licenseBatch.length > 1
                  )?.length
                }
                type={cardFilter.standard}
                currentLicenceFilter={currentLicenceFilter}
                setCurrentLicenceFilter={setCurrentLicenceFilter}
                isCurrentFilter={currentLicenceFilter === cardFilter.standard}
                icon={<LicenseIconAdmin />}
              /> */}

      {/* <DashboardCard
        setAdminDock={setAdminDock}
        title={"org-query"}
        count={
          organisationList?.filter((data) => data?.contacted === "yes")?.length
        }
        type={cardFilter.contactUs}
        currentLicenceFilter={currentLicenceFilter}
        setCurrentLicenceFilter={setCurrentLicenceFilter}
        isCurrentFilter={currentLicenceFilter === cardFilter.contactUs}
        icon={<ContactsIcon sx={{ fontSize: 50, color: theme.col_3 }} />}
      /> */}

      {tabRoutes?.map((data) => {
        return (
          <Card
            sx={{
              width: "90%",
              py: 0.7,
              borderRadius: "0px 40px 40px 0px",
              cursor: "pointer",
              backgroundColor:
                pathName === data?.toLowerCase() ? theme.col_2_alpha : "",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              setSearch('')
              navigate(
                `/admin-dashboard?${data?.toLowerCase()}${
                  data?.toLowerCase() === "referrals"
                    ? "?tab=referral-list"
                    : ""
                }`,
                {
                  replace: true,
                }
              );
              setCurrentLicenceFilter(null);
            }}
          >
            <Box display="flex" flexDirection="column" gap={1} width="100%">
              <Box
                display="flex"
                flex="1"
                flexDirection="column"
                justifyContent="center"
                px={2.5}
              >
                <Typography
                  fontWeight="bold"
                  color={
                    pathName === data?.toLowerCase() ? theme.col_2 : theme.col_6
                  }
                  fontSize={font.size.fs_3}
                  textTransform="capitalize"
                >
                  {data?.replace(/-/gi, " ")}
                </Typography>
              </Box>
            </Box>
          </Card>
        );
      })}
    </Box>
  );
};

export const AdminDashBoard = ({ setAdminDock, adminDock }) => {
  const {
    organisationList,
    setOrganisationList,
    dashboardQuery,
    adminList,
    filterOrgList,
  } = useContext(ApplicationContext);
  const pathName = useLocation()?.search?.split("?")[1];
  console.log(pathName, "path");
  console.log(adminList, "admin");
  const [activeTab] = useState(0);
  const [noOfEmployees, setNoOfEmployees] = useState(null);
  const [noOfEmployeesChange, setNoOfEmployeesChange] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [loaderState, setLoaderState] = useState(false);
  const [ancher, setAncher] = useState(null);
  const [filterBy, setFilterBy] = useState("");
  const [search, setSearch] = useState("");
  // const [organisationList, setOrganisationList] = useState([]);
  const [detailsDialog] = useState({});

  // const dashboardQuery = useMediaQuery("(max-width:967px)");
  console.log(activeTab);

  const cardFilter = {
    all: "",
    demo: "trial",
    standard: "standard",
    contactUs: "yes",
  };

  const [currentLicenceFilter, setCurrentLicenceFilter] = useState(
    cardFilter.all
  );

  //   let registeredUsers = [
  //     { name: "Mr Beast", designation: "UI Designer" },
  //     { name: "Andrew Jacked", designation: "UI Designer" },
  //     { name: "Emma Doran", designation: "UI Designer" },
  //     { name: "Mr Beast", designation: "UI Designer" },
  //   ];
  //   let navItems = [
  //     { label: "Profile", icon: <LicenseIcon activeTab={activeTab} /> },
  //     {
  //       label: "Users",
  //       icon: (
  //         <PersonIcon
  //           sx={{
  //             color: activeTab === 1 ? theme.col_2 : theme.col_4,
  //             fontSize: "33px",
  //           }}
  //           activeTab={activeTab}
  //         />
  //       ),
  //     },
  //     // {
  //     //   label: "Users",
  //     //   icon: (
  //     //     <PersonIcon
  //     //       sx={{
  //     //         color: activeTab === 2 ? theme.col_2 : theme.col_4,
  //     //         fontSize: "33px",
  //     //       }}
  //     //       activeTab={activeTab}
  //     //     />
  //     //   ),
  //     // },
  //     // {
  //     //   label: "Users",
  //     //   icon: (
  //     //     <PersonIcon
  //     //       sx={{
  //     //         color: activeTab === 3 ? theme.col_2 : theme.col_4,
  //     //         fontSize: "33px",
  //     //       }}
  //     //       activeTab={activeTab}
  //     //     />
  //     //   ),
  //     // },
  //   ];
  // useEffect(() => {
  //   const getOrganisations = async () => {
  //     try {
  //       let response = await organizationList();
  //       console.log(response, "list");
  //       setOrganisationList(response.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };
  //   getOrganisations();
  // }, []);
  // const handleDetails = (users) => {
  //   setDetailsDialog(users);
  //   setConfirmModal(true);
  // };
  console.log(detailsDialog, "ddd");

  let date = new Date(detailsDialog?.createdAt)?.toDateString().split(" ");
  console.log(date);
  console.log(filterBy?.toLowerCase(), cardFilter.demo, "seach");
  useEffect(() => {
    setOrganisationList(
      filterOrgList.filter((data) =>
        filterBy === "Trial"
          ? data.licenseBatch.length === 1
          : data.licenseBatch?.length > 1
      )
    );
    if (!filterBy) {
      setOrganisationList(filterOrgList);
    }
  }, [filterBy]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Box
        flex="1"
        display="flex"
        gap={"25px"}
        height="88%"
        // flexDirection="column"

        // padding={dashboardQuery ? "10px" : "0px 95px"}
        // paddingBottom={dashboardQuery ? "70px" : "30px"}
      >
        {/* count card */}
        {dashboardQuery ? (
          <>
            <Drawer open={adminDock} onClose={() => setAdminDock(false)}>
              {" "}
              <AdminNav
              setSearch={setSearch}
                pathName={pathName}
                setAdminDock={setAdminDock}
                setCurrentLicenceFilter={setCurrentLicenceFilter}
                currentLicenceFilter={currentLicenceFilter}
                cardFilter={cardFilter}
                organisationList={organisationList}
              />
            </Drawer>
          </>
        ) : (
          <AdminNav
          setSearch={setSearch}
            pathName={pathName}
            setAdminDock={setAdminDock}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            currentLicenceFilter={currentLicenceFilter}
            cardFilter={cardFilter}
            organisationList={organisationList}
          />
        )}

        <Box
          display={"flex"}
          flexDirection="column"
          gap={2}
          height="100%"
          width="100%"
          border={`1px solid ${theme.bgBorder}`}
          borderRadius="8px"
          backgroundColor={theme.col_4}
          alignItems="center"
          position="relative"
          // overflow="auto"

          // pb={4}
        >
          {loaderState && <GlobalLoaders />}

          <Box
            display="flex"
            alignItems="center"
            width="98%"
            pt={3}
            gap={"21px"}
            position="sticky"
            top={"0px"}
            left="0px"
          >
            <TextFieldMA
              id="emp"
              type="search"
              autoComplete="off"
              // defaultValue={searchedEmpQuery}
              // disabled
              value={search}
              onChange={(e) => setSearch(e.target.value?.toLowerCase())}
              size="small"
              fullWidth
              placeholder="Search"
              InputProps={{
                style: {
                  border: "none",
                },
                startAdornment: (
                  <InputAdornment>
                    <IconButton size="small">
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                background: grey[100],
                borderRadius: "32px",
                "& fieldset": { border: "none" },
                "&.MuiInputBase-formControl": {
                  border: "none",
                  outline: "none",
                },
              }}
            />
            {(pathName === "company" || pathName === "org-query") && (
              <Box display="flex" gap="2px" alignItems="center">
                <ButtonCustom
                  onClick={(e) => setAncher(e.currentTarget)}
                  borderRadius="40px"
                  // onClick={handleFollowUp}
                  // fullWidth={true}
                  // disabled={!followComment}
                  height="35px"
                  // borderRadius="42px"
                  // size="large"
                  background={""}
                  border={`2px solid ${theme.col_3_alpha}`}
                  backgroundRipple={theme.col_3_alpha}
                  focusColor={theme.col_1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  typography={
                    <Typography
                      fontFamily={font.family.fm_2}
                      textTransform={"capitalize"}
                      fontSize={font.size.fs_3}
                      padding={"12px"}
                      // fontWeight="bold"
                      color={theme.col_3}
                      whiteSpace={"nowrap"}
                    >
                      Filter By {filterBy}
                    </Typography>
                  }
                />
                {!filterBy ? (
                  <> </>
                ) : (
                  <IconButton onClick={() => setFilterBy(null)}>
                    <Cancel sx={{ fontSize: "27px", color: theme.col_2 }} />
                  </IconButton>
                )}
                <Menu
                  onChange={(e) => console.log(e.target.value, "target")}
                  open={Boolean(ancher)}
                  onClose={() => setAncher(null)}
                  anchorEl={ancher}
                >
                  <Box display="flex" flexDirection="column" gap="12px">
                    <Box display="flex" flexDirection="column">
                      {Array.of("Trial", "Standard").map((data) => {
                        return (
                          <MenuItem
                            onClick={() => {
                              setFilterBy(data);
                              setAncher(null);
                              // setCurrentLicenceFilter(data?.toLowerCase())
                            }}
                          >
                            {data}
                          </MenuItem>
                        );
                      })}
                    </Box>
                  </Box>
                </Menu>
              </Box>
            )}
          </Box>
          {pathName === "company" || pathName === "org-query" ? (
            <AdminDashboardTable
              adminList={adminList}
              organisationList={organisationList
                ?.filter((item, index) => {
                  if (pathName === "company") {
                    return item;
                  }

                  if (currentLicenceFilter === cardFilter.demo) {
                    console.log("yes trial");
                    return item.licenseBatch?.length === 1;
                  }

                  if (currentLicenceFilter === cardFilter.standard) {
                    console.log("yes standard");
                    return item.licenseBatch?.length > 1;
                  }

                  if (pathName === "org-query") {
                    // return item.isContactUs ===
                    console.log("yes cont");

                    return item.contacted === "yes";
                  }

                  return false;
                })
                .filter((item) => {
                  if (item?.companyName?.toLowerCase()?.includes(search)) {
                    console.log(item, "itemmm");
                    return item;
                  }
                  if (item?.discount?.toString()?.includes(search)) {
                    console.log(item, "itemmm");
                    return item;
                  }
                  if (!search) {
                    return item;
                  }
                  return false;
                })}
              setOrganisationList={setOrganisationList}
            />
          ) : (
            <RouteHandler
              loaderState={loaderState}
              setLoaderState={setLoaderState}
              search={search}
              pathName={pathName}
            />
          )}
          {/* <Box
                  display={"flex"}
                  alignItems="center"
                  height="90px"
                  width="95%"
                  // border={`1px solid ${theme.bgBorder}`}
                  borderRadius="8px"
                // backgroundColor={theme.col_4}
                // padding={2}
                >
                  <Typography variant="h4" color={theme.col_6}>
                    Company List
                  </Typography>
                </Box> */}
        </Box>
      </Box>

      <Dialog
        open={confirmModal}
        fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "409px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap="13px"
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Company Details
              </Typography>
              <IconButton onClick={() => setConfirmModal(false)}>
                <CancelIcon sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              width="100%"
              gap="5px"
            >
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Name : {detailsDialog?.name}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Email : {detailsDialog?.email}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Verified : {detailsDialog?.isVerfied ? "Yes" : "No"}
              </Typography>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Date of Creation : {date[2]} {date[1]} {date[3]}
              </Typography>
            </Box>
            <Box
              display="flex"
              gap="14px"
              alignItems="center"
              flexDirection="column"
              width="100%"
              backgroundColor={theme.col_4}
            >
              <TextFieldMA
                size="small"
                required
                type="number"
                error={
                  noOfEmployees === null
                    ? false
                    : noOfEmployees === ""
                    ? true
                    : false
                }
                helperText={
                  noOfEmployees === null
                    ? ""
                    : noOfEmployees === ""
                    ? "No of employees is required"
                    : ""
                }
                value={noOfEmployeesChange}
                onBlur={(e) =>
                  e.target.value < 0 ? 0 : setNoOfEmployees(e.target.value)
                }
                onChange={(e) =>
                  e.target.value < 0
                    ? 0
                    : setNoOfEmployeesChange(e.target.value)
                }
                fullWidth
                label="Number of Employees"
              />
              <Box
                display="flex"
                gap="14px"
                alignItems="center"
                justifyContent="center"
                width="100%"
                backgroundColor={theme.col_4}
              >
                <ButtonCustom
                  borderRadius="40px"
                  // onClick={handleResetPassword}
                  fullWidth={false}
                  disabled={false}
                  width="50%"
                  height="35px"
                  // borderRadius="42px"
                  // size="large"
                  background={theme.col_3}
                  backgroundRipple={theme.col_2}
                  focusColor={theme.col_1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  typography={
                    <Typography
                      fontFamily={font.family.fm_2}
                      textTransform={"capitalize"}
                      fontSize={font.size.fs_3}
                      // fontWeight="bold"
                      color={theme.col_4}
                    >
                      Approve
                    </Typography>
                  }
                />
                <ButtonCustom
                  borderRadius="40px"
                  // onClick={handleResetPassword}
                  fullWidth={false}
                  disabled={false}
                  width="50%"
                  height="35px"
                  variant="outlined"
                  color={"error"}
                  background={theme.col_4}
                  backgroundRipple={theme.col_4}
                  focusColor={theme.col_2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  typography={
                    <Typography
                      fontFamily={font.family.fm_2}
                      textTransform={"capitalize"}
                      fontSize={font.size.fs_3}
                      // fontWeight="bold"
                      color={theme.col_13}
                    >
                      Revoke
                    </Typography>
                  }
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

const RouteHandler = ({
  adminList,
  organisationList,
  setOrganisationList,
  pathName,
  search,
  loaderState,
  setLoaderState,
}) => {
  switch (pathName) {
    case "referral":
      return (
        <ReferalTable
          search={search}
          loaderState={loaderState}
          setLoaderState={setLoaderState}
        />
      );
    default:
      return (
        <ReferalTable
          search={search}
          loaderState={loaderState}
          setLoaderState={setLoaderState}
        />
      );
  }
};

const ReferalTable = ({ search, loaderState, setLoaderState }) => {
  const { referalList, setReferalList, adminProfileDetail } =
    useContext(ApplicationContext);
  const errorHandler = useErrorHandler();
  const navigate = useNavigate();
  const route = useLocation()?.search?.split("=")[1];
  console.log(route);
  const [openAccord, setOpenAccord] = useState([]);
  const [openUserInfoDialog, setOpenUserInfoDialog] = useState(null);
  const [openMarkReqDailog, setOpenMarkReqDailog] = useState(null);
  const [inputMarkReq, setInputMarkReq] = useState(null);

  let subscriptionTypes = {
    "-2": "None",
    "-1": "Trial",
    0: "Standard",
    1: "Student",
  };
  let tabs = ["referral-list", "redeem-requests"];
  const handleSelect = (list) => {
    let checkExist = openAccord.some((some) => some?._id === list?._id);
    let index = openAccord.findIndex((fi) => fi?._id === list?._id);
    !checkExist ? openAccord.push(list) : openAccord.splice(index, 1);
    setOpenAccord([...openAccord]);
  };
  const handleSearch = (filter) => {
    let data =
      filter?.userName?.toLowerCase()?.includes(search) ||
      filter?.email?.toLowerCase()?.includes(search) ||
      filter?.referCode?.toLowerCase()?.includes(search) ||
      (search?.includes("trial") && filter?.subscriptionType === -1) ||
      !search;
    console.log(data, "sssss");
    return data;
  };

  const handleClose = () => {
    setOpenUserInfoDialog(null);
    setOpenMarkReqDailog(null);
    setInputMarkReq(null);
  };

  const markRequest = async () => {
    setLoaderState(true);
    try {
      let response = await markRequest_API(
        {
          userEmail: openMarkReqDailog?.email,
          paidAmount: inputMarkReq?.amount,
          ispaid: inputMarkReq?.isPaid,
          activeInvoiceId: openMarkReqDailog?.invoiceInfo?._id,
          invoicePaidDate: dayjs(inputMarkReq?.date),
        },
        adminProfileDetail?.email
      );
      errorHandler(response, setLoaderState);
      if (response.status === HttpStatusCode.Ok) {
        getReferal();
        handleClose();
      }
      console.log(response, "responseMark");
    } catch (error) {
      console.log(error);
    }
  };

  const getReferal = async (data) => {
    try {
      let response = await referalList_Api(adminProfileDetail?.email);
      console.log(response, "listReferal");
      if (response.status === HttpStatusCode.Ok) {
        setReferalList(response.data?.users);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenMarkReq = (list) => {
    setInputMarkReq({
      amount: list?.invoiceInfo?.raiseAmount,
      date: dayjs(),
      isPaid: true,
    });
    setOpenMarkReqDailog(list);
  };
  console.log(inputMarkReq, "inputsMark");
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      height="100%"
      overflow="auto"
    >
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        gap="9px"
        p="19px"
        position="sticky"
        top="0px"
        left="0px"
        backgroundColor={theme.col_4}
      >
        {tabs?.map((list, i) => {
          return (
            <Typography
              onClick={() => navigate(`/admin-dashboard?referrals?tab=${list}`)}
              padding="6px 10px 6px 10px"
              sx={{ cursor: "pointer" }}
              fontSize={font.size.fs_3}
              backgroundColor={route === list && theme.col_2}
              borderRadius="8px"
              color={route === list && theme.col_4}
              textTransform="capitalize"
            >
              {list?.replace(/-/gi, " ")}
            </Typography>
          );
        })}
      </Box>
      {route === tabs[0] ? (
        <Box display="flex" flexDirection="column" flex="1">
          {referalList
            ?.filter((filter) => handleSearch(filter))
            .map((list, i) => {
              return (
                <Box
                  sx={{ display: "flex", flexDirection: "column" }}
                  border={`1px solid ${theme.col_2_alpha}`}
                >
                  <Box
                    onClick={() => handleSelect(list)}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    padding={"17px"}
                    sx={{ cursor: "pointer" }}
                    display="flex"
                    alignItems="center"
                    border={
                      openAccord.some((some) => some?._id === list?._id) &&
                      `2px solid ${theme.col_2}`
                    }
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      width="100%"
                      gap={"20px"}
                    >
                      <Box
                        display="flex"
                        // width={"20%"}
                        flex="1"
                        minWidth={"253px"}
                        alignItems="center"
                        gap="12px"
                        borderRight={`1px solid ${theme.col_2_alpha}`}
                        paddingRight="40px"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          width="40px"
                          minWidth="40px"
                          height="40px"
                          borderRadius="50px"
                          flexDirection="column"
                          justifyContent="center"
                          backgroundColor={theme.col_2_alpha}
                        >
                          <Typography
                            fontFamily={font.family.fm_2}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                            color={theme.col_2}
                            textTransform="capitalize"
                          >
                            {stringToArray(list?.userName)}
                          </Typography>
                        </Box>

                        <Box overflow="hidden">
                          <Typography
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            {list?.userName}
                          </Typography>
                          <Typography
                            textOverflow="ellipsis"
                            sx={{ whiteSpace: "nowrap" }}
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            overflow="hidden"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            {list?.email}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        // width={"11%"}
                        flex="1"
                        minWidth={"140px"}
                        alignItems="center"
                        gap="12px"
                        borderRight={`1px solid ${theme.col_2_alpha}`}
                        // paddingRight="10px"
                      >
                        <Box overflow="hidden">
                          <Typography
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            Refer code
                          </Typography>
                          <Typography
                            textOverflow="ellipsis"
                            sx={{ whiteSpace: "nowrap" }}
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            overflow="hidden"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            {list?.referCode || "-"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        // width={"11%"}
                        flex="1"
                        minWidth={"140px"}
                        alignItems="center"
                        gap="12px"
                        borderRight={`1px solid ${theme.col_2_alpha}`}
                        // paddingRight="10px"
                      >
                        <Box overflow="hidden">
                          <Typography
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            Company
                          </Typography>
                          <Typography
                            textOverflow="ellipsis"
                            sx={{ whiteSpace: "nowrap" }}
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            overflow="hidden"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            {list?.organizationName || "-"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        display="flex"
                        width={"11%"}
                        minWidth={"140px"}
                        alignItems="center"
                        gap="12px"
                        borderRight={`1px solid ${theme.col_2_alpha}`}
                        // paddingRight="10px"
                      >
                        <Box
                          overflow="hidden"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <Typography
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            Total referrals
                          </Typography>
                          <Typography
                            textOverflow="ellipsis"
                            sx={{ whiteSpace: "nowrap" }}
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            overflow="hidden"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            {list?.referInfo?.total || "-"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        // width={"11%"}
                        flex="1"
                        minWidth={"140px"}
                        alignItems="center"
                        gap="12px"
                        // borderRight={`1px solid ${theme.col_2_alpha}`}
                        // paddingRight="10px"
                      >
                        <Box overflow="hidden">
                          <Typography
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            Created At
                          </Typography>
                          <Typography
                            textOverflow="ellipsis"
                            sx={{ whiteSpace: "nowrap" }}
                            fontFamily={font.family.fm_3}
                            fontSize={font.size.fs_3}
                            overflow="hidden"
                          >
                            {/* <LicenseIcon activeTab={2} /> */}
                            {dayjs(list?.createdAt).format("DD MMM YYYY") ||
                              "-"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <ArrowForwardIosSharpIcon
                      sx={{
                        fontSize: font.size.fs_5,
                        color: `${theme.col_2} !important`,
                        transition: "0.5s ease",
                        transform: openAccord.some(
                          (some) => some?._id === list?._id
                        )
                          ? "rotate(90deg)"
                          : "",
                      }}
                    />
                  </Box>
                  <Box
                    height={
                      openAccord.some((some) => some?._id === list?._id)
                        ? "100%"
                        : "0px"
                    }
                    sx={{ transition: "0.5s ease" }}
                    overflow="hidden"
                  >
                    <TableContainer
                      style={{
                        borderRadius: "8px",
                        border: `1px solid ${theme.bgBorder}`,
                        minHeight: "420px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Table
                        className="tableEmployees"
                        size="small"
                        stickyHeader
                      >
                        <TableHead sx={{ height: "52px" }}>
                          <TableCell>Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell> Created At </TableCell>
                          <TableCell> Subscription type </TableCell>
                        </TableHead>
                        <TableBody>
                          {list?.referInfo?.users?.map((data, i) => {
                            return (
                              <TableRow sx={{ height: "50px" }}>
                                <TableCell>{data?.userName}</TableCell>
                                <TableCell>{data?.email}</TableCell>
                                <TableCell>
                                  {dayjs(data?.date).format("DD MMM YYYY")}
                                </TableCell>
                                <TableCell>
                                  {subscriptionTypes[data?.subscriptionType]}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      {list?.referInfo?.users?.length === 0 ? (
                        <Box
                          display="flex"
                          width="100%"
                          alignItems="center"
                          justifyContent="center"
                          height="100%"
                          flexDirection="column"
                          flex="1"
                        >
                          <Box
                            display="flex"
                            px={3}
                            backgroundColor={theme.col_2_alpha}
                            height="80px"
                            borderRadius="13px"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Typography
                              fontFamily={font.family.fm_2}
                              color={theme.col_2}
                              textAlign="center"
                              fontSize={font.size.fs_5}
                              fontWeight="bold"
                            >
                              No referrals yet
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}
                    </TableContainer>
                  </Box>
                </Box>
              );
            })}
          {referalList?.length === 0 ? (
            <Box
              display="flex"
              width="100%"
              alignItems="center"
              justifyContent="center"
              height="100%"
              flexDirection="column"
              flex="1"
            >
              <Box
                display="flex"
                px={3}
                backgroundColor={theme.col_2_alpha}
                height="80px"
                borderRadius="13px"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  color={theme.col_2}
                  textAlign="center"
                  fontSize={font.size.fs_5}
                  fontWeight="bold"
                >
                  No data found
                </Typography>
              </Box>
            </Box>
          ) : (
            ""
          )}
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" height="85%">
          <TableContainer
            style={{
              borderRadius: "8px",
              border: `1px solid ${theme.bgBorder}`,
              minHeight: "420px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Table className="tableEmployees" size="small" stickyHeader>
              <TableHead sx={{ height: "52px" }}>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell> Created At </TableCell>
                <TableCell> Subscription type </TableCell>
                <TableCell align="center"> Banking info </TableCell>
                <TableCell align="center"> Action </TableCell>
              </TableHead>
              {/* <TableBody>
                          {list?.referInfo?.users?.map((data, i) => {
                            return (
                              <TableRow sx={{ height: "50px" }}>
                                <TableCell>{data?.userName}</TableCell>
                                <TableCell>{data?.email}</TableCell>
                                <TableCell>
                                  {dayjs(data?.date).format("DD MMM YYYY")}
                                </TableCell>
                                <TableCell>
                                  {subscriptionTypes[data?.subscriptionType]}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody> */}
              <TableBody>
                {referalList
                  ?.filter(
                    (filter) => handleSearch(filter) && filter?.isActiveInvoice
                  )
                  ?.map((list, i) => {
                    return (
                      <TableRow sx={{ height: "50px" }}>
                        <TableCell>{list?.userName}</TableCell>
                        <TableCell>{list?.email}</TableCell>
                        <TableCell>
                          {" "}
                          {dayjs(list?.createdAt).format("DD MMM YYYY") || "-"}
                        </TableCell>
                        <TableCell>
                          {subscriptionTypes[list?.subscriptionType]}
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip arrow title="User banking details">
                            <AccountBalance
                              onClick={() =>
                                setOpenUserInfoDialog(list?.invoiceInfo)
                              }
                              sx={{
                                fontSize: font.size.fs_2,
                                color: theme.col_3,
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                          <ButtonCustom
                            onClick={() => handleOpenMarkReq(list)}
                            variant="contained"
                            size="small"
                            background={theme.col_3}
                            borderRadius="100px"
                            typography="Mark request"
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            {referalList?.filter(
              (filter) => handleSearch(filter) && filter?.isActiveInvoice
            )?.length === 0 ? (
              <Box
                display="flex"
                width="100%"
                alignItems="center"
                justifyContent="center"
                height="100%"
                flexDirection="column"
                flex="1"
              >
                <Box
                  display="flex"
                  px={3}
                  backgroundColor={theme.col_2_alpha}
                  height="80px"
                  borderRadius="13px"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography
                    fontFamily={font.family.fm_2}
                    color={theme.col_2}
                    textAlign="center"
                    fontSize={font.size.fs_5}
                    fontWeight="bold"
                  >
                    Redeem requests not found
                  </Typography>
                </Box>
              </Box>
            ) : (
              ""
            )}
          </TableContainer>
        </Box>
      )}

      <Dialog
        open={Boolean(openMarkReqDailog)}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            minWidth: "432px",
            maxWidth: "40%",
          },
        }}
        onClose={handleClose}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="19px"
          gap="19px"
        >
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="8px"
          >
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              flex="1"
              justifyContent="space-between"
              gap="40px"
              pb={2}
            >
              <Typography
                fontSize={font.size.fs_2}
                color={theme.col_3}
                fontWeight="bold"
              >
                Mark request
              </Typography>
              <IconButton onClick={handleClose}>
                <Close sx={{ fontSize: "27px", color: theme.col_6 }} />
              </IconButton>
            </Box>

            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap="18px"
            >
              <TextFieldMA
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
                label="Amount"
                value={inputMarkReq?.amount}
                onChange={(e) =>
                  setInputMarkReq({ ...inputMarkReq, amount: e.target.value })
                }
              />
              <Box
                width="100%"
                display="flex"
                flexDirection="column"
                gap="12px"
              >
                <DatePicker
                  sx={{ width: "100%" }}
                  label="Enter payment date"
                  size="small"
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                      sx: {
                        ".MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.col_2,
                        },
                        ".MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          { borderColor: theme.col_2, color: theme.col_2 },
                        ".MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: theme.col_2,
                          },
                        ".MuiInputLabel-root.Mui-focused": {
                          color: theme.col_2,
                        },
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "50px",
                      },
                    },
                  }}
                  value={inputMarkReq?.date}
                  onChange={(e) =>
                    setInputMarkReq({ ...inputMarkReq, date: e })
                  }
                />
                <TextFieldMA
                  size="small"
                  fullWidth
                  label="Message"
                  multiline
                  rows={3}
                  value={inputMarkReq?.message}
                  onChange={(e) =>
                    setInputMarkReq({
                      ...inputMarkReq,
                      message: e.target.value,
                    })
                  }
                />
                <Box
                  width="100%"
                  display="flex"
                  alignItems="center"
                  height="12px"
                >
                  <Typography fontSize={font.size.fs_3}>
                    Save Invoice
                  </Typography>
                  <Checkbox
                    checked={inputMarkReq?.isPaid}
                    onChange={(e) =>
                      setInputMarkReq({
                        ...inputMarkReq,
                        isPaid: e.target.checked,
                      })
                    }
                    size="small"
                  />
                </Box>
              </Box>
              <ButtonCustom
                variant="contained"
                size="small"
                onClick={markRequest}
                background={theme.col_3}
                borderRadius="100px"
                typography="Paid"
              />
            </Box>
          </Box>
        </Box>
      </Dialog>
      <Dialog
        open={Boolean(openUserInfoDialog)}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            minWidth: "432px",
            maxWidth: "40%",
            overflowWrap:'anywhere'
          },
        }}
        onClose={handleClose}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="19px"
          gap="19px"
        >
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="8px"
          >
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              flex="1"
              justifyContent="space-between"
              gap="40px"
            >
              <Typography
                fontSize={font.size.fs_2}
                color={theme.col_3}
                fontWeight="bold"
              >
                User Account Info
              </Typography>
              <IconButton onClick={handleClose}>
                <Close sx={{ fontSize: "27px", color: theme.col_6 }} />
              </IconButton>
            </Box>

            <Box width="100%" display="flex" alignItems="flex-start" gap="8px" >
              <Typography
                fontSize={font.size.fs_5}
                color={theme.col_2}
                fontWeight="bold"
                whiteSpace='nowrap'
              >
                Bank name:
              </Typography>
              <Typography fontSize={font.size.fs_5}>
                {openUserInfoDialog?.bankDetails?.bankName}
              </Typography>
            </Box>
            <Box width="100%" display="flex" alignItems="flex-start" gap="8px" >
              <Typography
                fontSize={font.size.fs_5}
                color={theme.col_2}
                fontWeight="bold"
                whiteSpace='nowrap'
              >
                Account number:
              </Typography>
              <Typography fontSize={font.size.fs_5}>
                {openUserInfoDialog?.bankDetails?.accountNumber}
              </Typography>
            </Box>
            <Box width="100%" display="flex" gap="8px" alignItems="flex-start">
              <Typography
                fontSize={font.size.fs_5}
                color={theme.col_2}
                fontWeight="bold"
                whiteSpace='nowrap'
              >
                IFSC/Sort code:
              </Typography>
              <Typography fontSize={font.size.fs_5}>
                {openUserInfoDialog?.bankDetails?.IFSCCode}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};
const DashboardCard = ({
  title,
  count,
  type,
  currentLicenceFilter,
  setCurrentLicenceFilter,
  isCurrentFilter,
  icon,
  setAdminDock,
}) => {
  const navigate = useNavigate();
  const pathName = useLocation()?.search?.split("?")[1];

  return (
    <Card
      sx={{
        width: "90%",
        // flex: 1,
        // minWidth: "222px",
        // maxWidth: 400,
        // height: "90px",
        py: 0.7,
        borderRadius: "0px 40px 40px 0px",
        cursor: "pointer",
        // border: isCurrentFilter
        //   ? `4px solid ${theme.col_2_alpha}`
        //   : `4px solid transparent`,
        backgroundColor:
          isCurrentFilter && pathName !== "referrals"
            ? theme.col_2_alpha
            : "transparent",
        boxShadow: "none",
        display: "flex",
        // justifyContent: "center",
        alignItems: "center",
      }}
      onClick={() => {
        type !== "registered" && setCurrentLicenceFilter(type);
        setAdminDock(false);
        navigate(`/admin-dashboard?${title}`);
      }}
    >
      {/* <CardContent sx={{ pb: 0 }}> */}
      <Box display="flex" flexDirection="column" gap={1} width="100%">
        {/* <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {icon}
        </Box> */}
        <Box
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="center"
          px={2.5}
          // alignItems="center"
          // gap={2}
        >
          {/* <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
          > */}
          <Typography
            fontWeight="bold"
            textTransform="capitalize"
            color={
              isCurrentFilter && pathName !== "referals"
                ? theme.col_2
                : theme.col_6
            }
            fontSize={font.size.fs_3}
          >
            {title?.replace(/-/gi, " ")}
          </Typography>
          {/* <Typography color={theme.col_6} fontSize="32px" component="div">
              {count}
            </Typography> */}
          {/* </Box> */}
        </Box>

        {/* <Box display="flex" flexDirection="column" gap={2} height="100%">
        <Box display="flex" alignItems="center" >
          <Typography color={theme.col_2} variant="h5" gutterBottom>
            {title}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" flexWrap="wrap" height="100%" >

          <VerifiedUser sx={{ fontSize: 60, color: theme.col_3 }} />
          <Typography color={theme.col_6} variant="h4" component="div" flex={1}>
            {count}
          </Typography>
        </Box>
      </Box> */}
      </Box>
      {/* </CardContent> */}
    </Card>
  );
};
